import React from "react";
import '../styles/helper.css';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const LightRoundBtn = ({ title, bg, func }) => {
    return (
        <button
            className="light-round-btn"
            onClick={func}
            style={{ backgroundColor: bg }}
        >
            {title}
        </button>
    );
};

const RegisterFilledBtn = ({ title, func }) => {
    return (
        <button className='register-filled-btn' href="register_form" >
            {title}
            <ChevronRightIcon className='chev-right-filled' />
        </button>
    );
};

const CustomFilledBtn = ({ title, func }) => {
    return (
        <button className="CustomFilledBtn">
            {title}
        </button>
    );
};

export { LightRoundBtn, RegisterFilledBtn, CustomFilledBtn };